// extracted by mini-css-extract-plugin
export default {"safeReliable":"style_safeReliable__sl30V","contentWrapper":"style_contentWrapper__qFOBI"};